import { render, staticRenderFns } from "./QueryComment.vue?vue&type=template&id=4779e7ce&scoped=true"
import script from "./QueryComment.vue?vue&type=script&lang=js"
export * from "./QueryComment.vue?vue&type=script&lang=js"
import style0 from "./QueryComment.vue?vue&type=style&index=0&id=4779e7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4779e7ce",
  null
  
)

export default component.exports